import angular from 'angular'

import envRaw from '../utils/env-raw'

import Template from './gallery-user.directive.ejs'

angular
  .module('ggs.user')
  .directive('ggsGalleryUser', GalleryUserDirective)

function GalleryUserDirective() {
  return {
    restrict: 'E',
    controller: GalleryUserController,
    bindToController: true,
    scope: {
      ggsPost: '<',
      ggsProperties: '<'
    },
    template: Template({
      LE: envRaw.liveEditMode
    })
  }

  function GalleryUserController($scope) {
    $scope.$ctrl = this
  }
}
